import { MutationTree } from 'vuex';
import { TemplatesState, TemplateType } from './types';

const mutations: MutationTree<TemplatesState> = {
  setTemplates(state, data: TemplateType[]) {
    const templates: TemplateType[] = [];
    data.forEach((item: TemplateType) => {
      try {
        const template = JSON.parse(item.template.replace(/\n/g, ''));
        if (template) {
          templates.push({ ...item, template });
        }
      } catch (e) {
        console.info(e);
      }
    });
    state.templates = templates;
  },
  setTemplatesIsLoading(state, data) {
    state.templatesIsLoading = data;
  },
};

export default mutations;
